import { render, staticRenderFns } from "./ship.vue?vue&type=template&id=ee8ac300&"
import script from "./ship.vue?vue&type=script&lang=ts&"
export * from "./ship.vue?vue&type=script&lang=ts&"
import style0 from "./ship.vue?vue&type=style&index=0&id=ee8ac300&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LoaderSpinner: require('/opt/atlassian/pipelines/agent/build/components/LoaderSpinner.vue').default,LoaderPayment: require('/opt/atlassian/pipelines/agent/build/components/LoaderPayment.vue').default})
